import { Injectable } from "@angular/core";
import { IPatientsGroup, PatientsGroup } from "@comunicare/comunicare-interfaces";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ApiService } from "./api.service";
import { BaseApiService } from "./baseApi.service";

@Injectable({
  providedIn: "root",
})
export class GroupApiService extends BaseApiService {
  constructor(private api: ApiService) {
    super(
      "Groups", // Theme !
      ["group"], // Post route paths
      ["groups"], // Get route paths
      ["group"], // Update route paths
      [] // Delete route paths
    );
  }

  public list(healthcareService: string, services?: string[]): Observable<PatientsGroup[]> {
    const params: any = {};
    if (healthcareService) {
      params.healthcareservice = healthcareService;
    }
    if (services) {
      params.services = JSON.stringify(services);
    }
    return this.api.get(this.readRoutes[0], params).pipe(
      map((values: IPatientsGroup[]) => {
        return values.map((v) => new PatientsGroup(v));
      })
    );
  }

  public listAll() {
    return this.api.get(this.readRoutes[0]).pipe(
      map((values: IPatientsGroup[]) => {
        return values.map((v) => new PatientsGroup(v));
      })
    );
  }

  public create(group: PatientsGroup): Observable<PatientsGroup> {
    return this.api.post(this.createRoutes[0], group).pipe(map((v: IPatientsGroup) => new PatientsGroup(v)));
  }

  public update(group: IPatientsGroup): Observable<PatientsGroup> {
    return this.api.put(this.updateRoutes[0], group).pipe(map((v: IPatientsGroup) => new PatientsGroup(v)));
  }
}
